import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
          h漫分类导航
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          按风格与来源精准分类，快速找到你感兴趣的h漫类型
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {categories.map((cat) => {
          const isPrimary = cat.color === 'primary';
          const isAccent = cat.color === 'accent';
          const iconBg = isPrimary
            ? 'bg-primary-100 text-primary-600'
            : isAccent
              ? 'bg-accent-100 text-accent-700'
              : 'bg-secondary-100 text-secondary-700';
          const hoverBorder = isPrimary
            ? 'hover:border-primary-300'
            : isAccent
              ? 'hover:border-accent-300'
              : 'hover:border-secondary-300';

          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group p-5 rounded-xl bg-background-50 border border-background-200/70 hover:shadow-md transition-all cursor-pointer block"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${iconBg} transition-colors`}>
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-400">{cat.articleCount} 篇内容</span>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className={`mt-3 flex items-center gap-1 text-sm font-medium ${
                isPrimary ? 'text-primary-500' : isAccent ? 'text-accent-600' : 'text-secondary-600'
              }`}>
                浏览分类
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}